/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import {
  APPLICATION_STATUS_CONTRACT_BASE,
  APPLICATION_STATUS_CONTRACT_DETAILS,
  APPLICATION_STATUS_CONTRACT_INSURANCE,
  APPLICATION_STATUS_DONE,
  APPLICATION_STATUS_POWER_OF_ATTORNEY,
  APPLICATION_STATUS_PERSONAL_AFFECTION,
  APPLICATION_STATUS_PERSONAL_AFFECTION_SUMMARY,
  APPLICATION_STATUS_SUMMARY,
} from "../applicationStatus";
import formStepsGenericContractLaw from "../formSteps";
import React from "react";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import progressBarSteps from "../progressBarSteps";
import Insurance from "../../../components/Form/Common/Insurance/Insurance";
import { isInsurancePartnered } from "../../productService";
import DataLeakContractBase from "../../../components/Form/ContractLaw/DataLeakContract/DataLeakContractBase";
import { FormSteps } from "../../../types/FormServiceBase";
import PersonalAffection from "../../../components/Form/ContractLaw/DataLeakContract/PersonalAffection";
import PersonalAffectionSummary from "../../../components/Form/ContractLaw/DataLeakContract/PersonalAffectionSummary";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_CONTRACT_BASE]: {
    title: "Antrag - Ihr Vertrag | Legalbird",
    applicationStatus: APPLICATION_STATUS_CONTRACT_BASE,
    stepUrl: "vertrag",
    render: (props: any) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"contract"} progress={15} />
        <DataLeakContractBase {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTRACT_DETAILS]: formStepsGenericContractLaw[APPLICATION_STATUS_CONTRACT_DETAILS],
  [APPLICATION_STATUS_CONTRACT_INSURANCE]: {
    title: "Antrag - Versicherung | Legalbird",
    applicationStatus: APPLICATION_STATUS_CONTRACT_INSURANCE,
    stepUrl: "versicherung",
    render: (props: any) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"insurance"} progress={82} />
        <Insurance {...props} withDeductible={isInsurancePartnered(props.product)} insuranceSubArea={"Privatrechtsschutz"} forceInsuredOptionHidden={true} />
      </>
    ),
  },
  [APPLICATION_STATUS_PERSONAL_AFFECTION]: {
    title: "Antrag - Persönliche Betroffenheit | Legalbird",
    applicationStatus: APPLICATION_STATUS_PERSONAL_AFFECTION,
    stepUrl: "betroffenheit",
    render: (props: any) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"insurance"} progress={82} />
        <PersonalAffection {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_PERSONAL_AFFECTION_SUMMARY]: {
    title: "Antrag - Persönliche Betroffenheit | Legalbird",
    applicationStatus: APPLICATION_STATUS_PERSONAL_AFFECTION_SUMMARY,
    stepUrl: "betroffenheit-uebersicht",
    render: (props: any) => (
      <>
        <ProgressBar steps={progressBarSteps} active={"insurance"} progress={82} />
        <PersonalAffectionSummary {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: formStepsGenericContractLaw[APPLICATION_STATUS_SUMMARY],
  [APPLICATION_STATUS_POWER_OF_ATTORNEY]: formStepsGenericContractLaw[APPLICATION_STATUS_POWER_OF_ATTORNEY],
  [APPLICATION_STATUS_DONE]: formStepsGenericContractLaw[APPLICATION_STATUS_DONE],
};

export default formSteps;
